import React from 'react'
import Calculator from './Calculator'

function App() {
  return (
    <div>
      <Calculator />
    </div>
  )
}

export default App